import React, { useState, useEffect, useCallback, useRef } from "react";

import { ProgressBar } from "react-bootstrap";
import Sound from "react-sound";
import { base, s3base } from "api.js";
import NoMicrophone from "views/NoMicrophone.jsx";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns.jsx";
import ReusableRecorder from "components/Recorder/ReusableRecorder";
import Beep from "Beep.js";

import "components/custom.css";
import MicWaveform from "../MicWaveform";
import RecordedWaveform from "components/Question/Speaking/RecordedWaveform";
import IOSAudioPlayer from './IOSAudioPlayer.jsx';
import { isIOSDevice } from 'util/deviceDetection';
import useAudioDuration from "hooks/useAudioDuration";

const RespondToSituation = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState("");
  const [isBlocked, setIsBlocked] = useState(false);
  const [question, setQuestion] = useState("");
  const [secondCount, setSecondCount] = useState(8);
  const [duration, setDuration] = useState(0);
  const [secondCount2, setSecondCount2] = useState(0);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [intervalId2, setIntervalId2] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [soundPer, setSoundPer] = useState(0);
  const [trans, setTrans] = useState("");
  const [volume, setVolume] = useState(90);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [beepStatus, setBeepStatus] = useState(false);
  const [position, setPosition] = useState(0);
  const [file, setFile] = useState("");
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [secondCount2Bckup, setSecondCount2Bckup] = useState(0);
  const [saveTranscript, setSaveTranscriptState] = useState(false);
  const [micPermitted, setMicPermitted] = useState(null);
  const [browserAllowed, setBrowserAllowed] = useState(true);
  const [audioFinished, setAudioFinished] = useState(false);
  const { audioDuration, audioSecondsLeft, handleAudioPlaying, resetAudioDuration } = useAudioDuration();

  const [mobileStarted, setMobileStarted] = useState(false);
  const [showMobileStartButton, setShowMobileStartButton] = useState(false);
  const [isStarting, setIsStarting] = useState(false);
  const [audioContextReady, setAudioContextReady] = useState(false);
  const [userGestureUsed, setUserGestureUsed] = useState(false);
  const audioContextRef = useRef(null);
  const startProcessTimeoutRef = useRef(null);
  const unlockedAudioRef = useRef(null); // pre-unlocked Audio element for iOS autoplay
  const handleRecordingCompleteRef = useRef(null);

  const { currentQuestion, total_questions } = props;
  const LIMIT = 40;

  // Refs to store mutable values and prevent dependency issues
  const recorderRef = useRef(null);
  const intervalsRef = useRef({
  intervalId: 0,
  intervalId2: 0,
  recordId: 0
  });

  // Store latest values in refs to avoid stale closures
  const latestValues = useRef({
  isBlocked,
  isRecording,
  secondCount,
  secondCount2,
  secondCount2Bckup,
  recordCount,
  soundStatus,
  trans,
  file,
  duration,
  blobURL
  });

  // Update refs when values change
  useEffect(() => {
  latestValues.current = {
    isBlocked,
    isRecording,
    secondCount,
    secondCount2,
    secondCount2Bckup,
    recordCount,
    soundStatus,
    trans,
    file,
    duration,
    blobURL
  };
  });

  // Timer functions that don't depend on state
  const timer = useCallback(() => {
  setSecondCount(prevSecondCount => {
    if (prevSecondCount === 0) {
    clearInterval(intervalsRef.current.intervalId);
    intervalsRef.current.intervalId = 0;
    return prevSecondCount;
    } else {
    return prevSecondCount - 1;
    }
  });
  }, []);
   const handleBeepFinishedPlaying = useCallback(() => {
    // Recording already started when beep began — just clear beep status
    setBeepStatus(false);
  }, []);

  const createAndPlayBeep = useCallback((audioContext) => {
  try {
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);
    oscillator.frequency.value = 800;
    oscillator.type = 'sine';
    gainNode.gain.setValueAtTime(0.3, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, audioContext.currentTime + 0.3);
    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + 0.3);
    setTimeout(() => {
        setBeepStatus(false);
    }, 300);
  } catch (error) {
    console.error('Error playing beep sound:', error);
      setBeepStatus(false);
  }
}, [handleBeepFinishedPlaying]);

const playMobileBeep = useCallback(() => {
  if (isIOSDevice()) {
      // iOS needs explicit AudioContext resume
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      let audioContext = audioContextRef.current;
      if (!audioContext) {
        audioContext = new AudioContext();
        audioContextRef.current = audioContext;
      }
      if (audioContext.state === 'suspended') {
        audioContext.resume().then(() => {
          createAndPlayBeep(audioContext);
          }).catch(() => {
            createAndPlayBeep(audioContext); // try anyway
        });
      } else {
        createAndPlayBeep(audioContext);
      }
    } catch (error) {
      console.error('iOS beep error:', error);
      setTimeout(() => {
          setBeepStatus(false);
      }, 300);
    }
  } else {
    // Android – try AudioContext, fallback to setTimeout if needed
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      let audioContext = audioContextRef.current;
      if (!audioContext) {
        audioContext = new AudioContext();
        audioContextRef.current = audioContext;
      }
      if (audioContext.state === 'suspended') {
        audioContext.resume().then(() => {
          createAndPlayBeep(audioContext);
        }).catch(() => {
          createAndPlayBeep(audioContext);
        });
      } else {
        createAndPlayBeep(audioContext);
      }
    } catch (error) {
      console.error('Android beep error, using fallback', error);
     setTimeout(() => {
      setBeepStatus(false);
        }, 300);
   }
  }
}, [createAndPlayBeep, handleBeepFinishedPlaying, isIOSDevice]);  

  const timer1 = useCallback(() => {
    setSecondCount2(prevSecondCount2 => {
      if (prevSecondCount2 === 0) {
        clearInterval(intervalsRef.current.intervalId2);
        intervalsRef.current.intervalId2 = 0;
        // setBeepStatus(true); // start()
        // On mobile, play custom beep; on desktop, use Sound component
        // Start recording immediately when beep plays so no words are missed
        startRecordingNow();
        if (isIOSDevice()) {
          playMobileBeep();
        } else {
          setBeepStatus(true);
        }
        setSoundStatus(false);
        return prevSecondCount2;
      } else {
        if (latestValues.current.secondCount2Bckup === 0) {
          setSecondCount2Bckup(prevSecondCount2);
        }
        return prevSecondCount2 - 1;
      }
    });
  }, []);

  const startProcess = useCallback(() => {
  if (!props.answer && props.data?.media_link) {
    const newIntervalId = setInterval(timer, 1000);
    intervalsRef.current.intervalId = newIntervalId;
    setIntervalId(newIntervalId);

    const audio_url = s3base + props.data.media_link;
    props.updateQuestionAudioUrlInPractice?.(audio_url);
  }
  }, [props.answer, props.data?.media_link, props.updateQuestionAudioUrlInPractice, timer]);

  // Initial mount effect
  useEffect(() => {
    const isMobile = isIOSDevice();
    if (isMobile) {
      setShowMobileStartButton(isMobile);
      setBrowserAllowed(true);
      return;
    }

  // mic access.
  navigator.mediaDevices
    .getUserMedia({ audio: true })
    .then(() => {
    // Permission Granted
    setIsBlocked(false);
    setMicPermitted(true);
    setBrowserAllowed(true);

    })
    .catch(() => {
    // Permission Denied
    setIsBlocked(true);
    setMicPermitted(false);
    setBrowserAllowed(true);
    });

  // Cleanup function for componentWillUnmount
  return () => {
    if (intervalsRef.current.intervalId) {
    clearInterval(intervalsRef.current.intervalId);
    }
    if (intervalsRef.current.intervalId2) {
    clearInterval(intervalsRef.current.intervalId2);
    }
    if (intervalsRef.current.recordId) {
    clearInterval(intervalsRef.current.recordId);
    }
    if (startProcessTimeoutRef.current) clearTimeout(startProcessTimeoutRef.current);
    if (audioContextRef.current) audioContextRef.current.close();
  };
  }, []);

  // Start process when permissions are granted
  useEffect(() => {
    if (micPermitted && browserAllowed) {
      // On mobile, set the initial countdown to 1 seconds
      // if (isIOSDevice() && mobileStarted) {
      //   setSecondCount(1);
      // } else {
      //   setSecondCount(8); // desktop default
      // }
      startProcess();
    }
  }, [micPermitted, browserAllowed, mobileStarted, startProcess]);

  // Handle props changes (getDerivedStateFromProps equivalent)
  const prevQuestionId = useRef(questionId);
  const prevRestart = useRef(props.restart);

//   useEffect(() => {
// 		console.log("props.restart===",props.restart);
//     if (props.data) {
//       const currentQuestionId = props.data.id;
//       if (
//         (questionId && questionId !== currentQuestionId) ||
//         (props.restart && props.restart !== prevRestart.current)
//       ) {
//         // Clear all intervals
//         if (intervalsRef.current.intervalId) clearInterval(intervalsRef.current.intervalId);
//         if (intervalsRef.current.intervalId2) clearInterval(intervalsRef.current.intervalId2);
//         if (intervalsRef.current.recordId) clearInterval(intervalsRef.current.recordId);

//         intervalsRef.current = { intervalId: 0, intervalId2: 0, recordId: 0 };

//         setCorrectFlag(true);
//         setRecordCount(0);
//         setSoundPer(0);
//         setIsRecording(false);
//         setSecondCount(8);
//         setSecondCount2(10);
//         setQuestionId(currentQuestionId);
//         setBlobURL("");
//         setReset(true);
//         setTrans("");
//         setSoundStatus(true);
//         setIntervalId2(0);
//         setDuration(0);
//         setIntervalId(0);
//       } else {
//         if (!questionId) {
//           setCorrectFlag(true);
//           setQuestionId(currentQuestionId);
//         }
//       }
//     }

//     prevQuestionId.current = questionId;
//     prevRestart.current = props.restart;
//   }, [props.data?.id, props.restart, questionId]);

  // // Handle reset state
  // useEffect(() => {
  //   if (reset) {
  //     const newIntervalId = setInterval(timer, 1000);
  //     intervalsRef.current.intervalId = newIntervalId;
  //     setIntervalId(newIntervalId);
  //     setReset(false);
  //   }
  // }, [reset, timer]);

  // // Handle restart and stopRecording props
  useEffect(() => {
    if (props.restart) {
      props.restartQue?.();
    }
  }, [props.restart, props.restartQue]);

  // useEffect(() => {
  //   if (props.stopRecording) {
  //     stopTest();
  //   }
  // }, [props.stopRecording]);

  // Handle correctFlag and question updates
  // useEffect(() => {
  //   if (props.data && correctFlag) {
  //     props.submit?.({ data: "", audio_text: "", duration: 0 });
  //     setCorrectFlag(false);
  //   }
  //   if (props.data) {
  //     setQuestion(props.data.question);
  //   }
  // }, [props.data?.id, correctFlag]);

  const start = useCallback(() => {
    setBeepStatus(true);
  }, []);

  const startRecordingNow = useCallback(() => {
    if (latestValues.current.isBlocked) return;

    if (recorderRef.current) {
      if (isIOSDevice() && audioContextRef.current) {
        audioContextRef.current.resume().then(() => {
          recorderRef.current.startRecording();
        }).catch(() => {
          recorderRef.current.startRecording(); // fallback
        });
      } else {
        recorderRef.current.startRecording();
      }
    }

    setIsRecording(true);
    setBlobURL("");
    setRecordCount(0);

    // Clear any existing recording interval
    if (intervalsRef.current.recordId) {
      clearInterval(intervalsRef.current.recordId);
    }

    // Start recording timer
    const newRecordId = setInterval(() => {
      setRecordCount(prevRecordCount => {
        if (prevRecordCount >= LIMIT) {
          clearInterval(intervalsRef.current.recordId);
          intervalsRef.current.recordId = 0;
          if (recorderRef.current) {
            recorderRef.current.stopRecording();
          }
          return LIMIT;
        }
        return prevRecordCount + 1;
      });
    }, 1000);

    intervalsRef.current.recordId = newRecordId;
    setRecordId(newRecordId);
  }, [isIOSDevice]);


  const stop = useCallback(async () => {
    if(!props.testMode){
      props.setIsStopped(false)
    }
  if (!latestValues.current.isBlocked && latestValues.current.isRecording && recorderRef.current) {
    recorderRef.current.stopRecording();
  }
  }, []);

//   const setTransFunction = useCallback((a) => {
// 	if (latestValues.current.trans !== a) {
// 	  setTrans(a);
// 	}
//   }, []);

//   const stopTest = useCallback(async () => {
// 	if (!latestValues.current.isBlocked && latestValues.current.isRecording && recorderRef.current) {
// 	  recorderRef.current.stopRecording();
// 	} else {
// 	  props.nextQuestion?.({
// 		data: latestValues.current.file,
// 		audio_text: latestValues.current.trans,
// 		duration: latestValues.current.duration,
// 	  });
// 	}
//   }, [props.nextQuestion]);

  const handleSongPlaying = useCallback((obj) => {
   setSoundPer((obj.position * 100) / obj.duration);
  handleAudioPlaying(obj);
  }, []);

  const handleSongFinishedPlaying = useCallback(() => {
  setSoundStatus(false);
   if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  props.soundChecked?.();
  setAudioFinished(true);
  }, [props.soundChecked]);

  const stopAudio = useCallback(() => {
  // Clear the countdown timer to prevent stuck state
  if (intervalsRef.current.intervalId2) {
    clearInterval(intervalsRef.current.intervalId2);
    intervalsRef.current.intervalId2 = 0;
  }
  setSoundStatus(false);
  setAudioFinished(true);
  resetAudioDuration();
  // Start 10-second countdown before recording
  setSecondCount2(10);
  const newIntervalId = setInterval(timer1, 1000);
  intervalsRef.current.intervalId2 = newIntervalId;
  setIntervalId2(newIntervalId);
  
   if(props.onMainAudioFinished){
      props.onMainAudioFinished();
    }
  }, [timer1]);

  const skip = useCallback(() => {
  if (intervalsRef.current.intervalId) {
    clearInterval(intervalsRef.current.intervalId);
    intervalsRef.current.intervalId = 0;
  }
  setSecondCount(0);
  }, []);

  const changeRange = useCallback((e) => {
  setVolume(e.target.value);
  console.log(e.target.value);
  }, []);

  const loadingSound = useCallback((obj) => {
  let d = obj.duration / 1000 + 9;
  if (obj.duration !== 0 && intervalsRef.current.intervalId2 === 0) {
   
    const newIntervalId = setInterval(timer1, 1000);
    intervalsRef.current.intervalId2 = newIntervalId;
    setSoundStatus(true);
    setIntervalId2(newIntervalId);
    setSecondCount2(Math.ceil(d));
    setSecondCount2Bckup(Math.ceil(d));
  }
  }, [timer1]);

  const changePlaybackSpeed = useCallback((speed) => {
    // Don't allow speed changes if audio has finished
    if (audioFinished) return;
    
    console.log(latestValues.current.secondCount2Bckup);
    if (speed !== playbackSpeed) {
      let seconds = latestValues.current.secondCount2Bckup;
      if (latestValues.current.secondCount === 0) {
        if (speed === 2 || speed === 1.5) {
          seconds = seconds / speed;
        }
      }
      setSoundKey(prevSoundKey => prevSoundKey + 1);
      setPlaybackSpeed(speed);
      setSecondCount2(Math.round(seconds));
    }
  }, [playbackSpeed, audioFinished]);

  const setSaveTranscript = useCallback((status) => {
  setSaveTranscriptState(status);
  }, []);

  const handleRecordingComplete = useCallback((data) => {
  setBlobURL(data.url);
  setIsRecording(false);
  setRecordCount(100);
  setFile(data.file);
  setDuration(data.duration);
  setTrans(data.transcript);

  // Update latestValues immediately
  latestValues.current.file = data.file;
  latestValues.current.duration = data.duration;
  latestValues.current.blobURL = data.url;
  latestValues.current.trans = data.transcript;

  const data_to_send = {
    data: data.file,
    audio_text: data.transcript,
    duration: data.duration,
    blob_url: data.url,
  };

  if (props.testMode) {
    props.nextQuestion?.(data_to_send);
  } else {
    props.submit?.(data_to_send, true);
    props.showResult?.();
  }
  }, [props.testMode, props.nextQuestion, props.submit, props.showResult]);

  // Keep the ref always pointing to the latest version
  handleRecordingCompleteRef.current = handleRecordingComplete;

  // Stable callback that never changes identity — prevents ReusableRecorder remount
  const stableHandleRecordingComplete = useCallback((data) => {
    handleRecordingCompleteRef.current(data);
  }, []); // empty deps = never recreated

 const handleMobileStart = useCallback(async () => {
  if (isStarting) return;
  setIsStarting(true);
  try {
    console.log('Mobile Start button clicked');

    // For iOS, create and resume AudioContext
    if (isIOSDevice()) {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (AudioContext) {
          audioContextRef.current = new AudioContext();
          if (audioContextRef.current.state === 'suspended') {
            await audioContextRef.current.resume();
          }
          // Warm up the audio system with a silent oscillator
          const oscillator = audioContextRef.current.createOscillator();
          const gainNode = audioContextRef.current.createGain();
          gainNode.gain.setValueAtTime(0.001, audioContextRef.current.currentTime);
          oscillator.connect(gainNode);
          gainNode.connect(audioContextRef.current.destination);
          oscillator.start();
          oscillator.stop(audioContextRef.current.currentTime + 0.1);
        }
      }
       // Unlock a reusable Audio element for iOS autoplay.
      // Calling play() synchronously inside this user-gesture handler permanently
      // unlocks this Audio object so it can play freely later (e.g. in canplaythrough).
      if (!unlockedAudioRef.current) {
        const ua = new Audio();
        // Minimal silent WAV so iOS accepts the play() call
        ua.src = 'data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=';
        const unlockPromise = ua.play();
        if (unlockPromise !== undefined) {
          unlockPromise
            .then(() => { ua.pause(); ua.currentTime = 0; })
            .catch(() => {}); // a rejected play() still partially unlocks on most iOS versions
        }
        unlockedAudioRef.current = ua;
      }

      // Request microphone permissions
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // We don't need to store the stream because ReusableRecorder requests its own,
      // but we keep it to mark permission as granted.
      setMicPermitted(true);
      setIsBlocked(false);
      
      stream.getTracks().forEach(track => track.stop());

      setMobileStarted(true);
      setShowMobileStartButton(false);
      setUserGestureUsed(true);
      setAudioContextReady(true);

      // The normal flow (startProcess) will now be triggered by the useEffect below
      setSecondCount(1); // set to 1 for mobile
    } catch (error) {
      console.error('Error in mobile start:', error);
      setMicPermitted(false);
      setIsBlocked(true);
    } finally {
      setIsStarting(false);
    }
  }, [isStarting, isIOSDevice]);

// useEffect(() => {
//   if (mediaStreamRef.current && recorderRef.current && recorderRef.current.setMediaStream) {
//     recorderRef.current.setMediaStream(mediaStreamRef.current);
//   }
// }, [mobileStarted]);

  const playSound = useCallback(() => {
  const { resultMode, data } = props;

  let sound = false;
  // Add additional check to prevent audio conflicts
  if (!resultMode && data && soundStatus && secondCount === 0 && !audioFinished) {
    sound = true;
  }

  return sound;
  }, [props.resultMode, props.data, soundStatus, secondCount, audioFinished]);

  const playingQuestionSectionLabel = useCallback(() => {
  let status = "";

  if (!isRecording) {
    if (secondCount !== 0 && soundStatus === true) {
    status = `Begining in ${secondCount} seconds`;
    } else if (secondCount === 0 && blobURL === "" && audioFinished === false) {
    status = "Playing question audio...";
    } else {
    status = "Question audio finished."; // just any case.
    }
  } else {
    status = "Question audio finished.";
  }
  return status;
  }, [isRecording, secondCount, soundStatus, blobURL]);

  const showSkipAudioWaitButton = useCallback(() => {
  let show_button = false;

  if (secondCount !== 0 && blobURL === "" && !isRecording) {
    show_button = true;
  }

  return show_button;
  }, [secondCount, blobURL, isRecording]);

  const recordingLabel = useCallback(() => {
  let label = "";
  if (secondCount === 0 && secondCount2 !== 0) {
    label = `Recording starts in ${secondCount2} seconds...`;
  } else if (blobURL === "" && isRecording) {
    label = "Recording audio...";
  } else if (blobURL !== "" && !isRecording) {
    label = "Recording Finished.";
  }
  return label;
  }, [secondCount, secondCount2, blobURL, isRecording]);

  const showStopRecordingButton = useCallback(() => {
  let button = false;

  const { testMode } = props;

  if (!testMode && isRecording) {
    button = true;
  }

  return button;
  }, [props.testMode, isRecording]);

  const showRecordedAudio = useCallback(() => {
  const { testMode } = props;

  let recorded_audio = false;
  if (blobURL && !testMode) {
    recorded_audio = true;
  }

  return recorded_audio;
  }, [blobURL, props.testMode]);

  const skipAudio = useCallback(() => {
  const { testMode } = props;

  let button = false;
  if (!testMode && soundStatus === true && secondCount === 0) {
    button = true;
  }

  return button;
  }, [props.testMode, soundStatus, secondCount]);

  const playBeep = useCallback(() => {
  const { resultMode } = props;

  let beep = false;
  if (!resultMode && beepStatus) {
    beep = true;
  }
  return beep;
  }, [props.resultMode, beepStatus]);

  if (isBlocked) {
  return <NoMicrophone />;
  }

  if (showMobileStartButton && !mobileStarted) {
  return (
    <div className="pmw-tabs-section d-flex align-items-center justify-content-center">
      <div className="ios-start-container text-center" style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        height: '200px'
      }}>
        <button
          className="btn btn-primary btn-lg"
          onClick={handleMobileStart}
          disabled={isStarting}
          style={{
            padding: '15px 30px',
            fontSize: '18px',
            borderRadius: '25px',
            background: 'linear-gradient(135deg, rgb(171 248 97) 0%, rgb(104 162 75) 100%)',
            border: 'none',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
            opacity: isStarting ? 0.7 : 1
          }}
        >
          <i className="fa fa-play-circle me-2"></i>
          {isStarting ? 'Starting...' : 'Start Practice'}
        </button>
        <div className="ios-instructions mt-4 p-3 bg-light rounded" style={{ maxWidth: '400px' }}>
          <small className="text-muted">
            <i className="fa fa-volume-up me-1"></i> Audio will play automatically after clicking
            <br />
            <i className="fa fa-microphone me-1 mt-1"></i> Recording will start after the question audio
          </small>
        </div>
      </div>
    </div>
  );
}

  return (
  <>
    {micPermitted && browserAllowed ? (
    <>
      <ReusableRecorder
      ref={recorderRef}
      onRecordingComplete={stableHandleRecordingComplete}
      maxDuration={40000}
      enableSpeechRecognition={true}
      fileName="retell-lecture.mp3"
      />

      {playSound() && (
        isIOSDevice() && mobileStarted ? (
          <IOSAudioPlayer
            audioUrl={s3base + props.data.media_link}
            onPlaying={handleSongPlaying}
            onLoading={loadingSound}
            onFinishedPlaying={handleSongFinishedPlaying}
            volume={volume}
            playbackRate={playbackSpeed}
            soundKey={soundKey}
            unlockedAudio={unlockedAudioRef.current}
          />
        ) : (
          <Sound
            url={s3base + props.data.media_link}
            playStatus={Sound.status.PLAYING}
            onPlaying={handleSongPlaying}
            onLoading={loadingSound}
            onFinishedPlaying={handleSongFinishedPlaying}
            volume={volume}
            playbackRate={playbackSpeed}
            key={soundKey}
          />
        )
      )}

      {!isIOSDevice() && playBeep() && (
      <Sound
        url={Beep}
        playStatus={Sound.status.PLAYING}
        onFinishedPlaying={handleBeepFinishedPlaying}
        onError={handleBeepFinishedPlaying}
      />
      )}

      <div className="question_section_height pmw-tabs-section d-flex align-items-start pmw-outer-wrapper recorded-wrapper challenge-content-wrapper visibility-visible m-0" id="retell-lec"
      // style={{
      //   minHeight: "220px", height: "100%"
      // }}
      >
      <div className="recorded-section h-100" style={{ width: "50%" }}>
        <div className="recorded-content">
        <div className="row">
          <div className="col-12">
          <ul className="recorded-list">
             <li>Status: </li>
                      <li>{playingQuestionSectionLabel()}</li>
                      {/* {secondCount === 0 && !isRecording && audioDuration > 0 && audioSecondsLeft > 0 && (
    <li>
      Audio ends in: {audioSecondsLeft}s 
    </li>
  )} */}
          </ul>
          </div>
          {/*<div className="col-2"><span className="volume-label">Volume</span></div>*/}
        </div>

        <div className="recorded-audio-wrapper" style={{ marginTop: "50px" }}>
          <div className="row">
          <div className="recorded-audio-outer">
            <ProgressBar now={soundPer} striped />

            <div className="volume-control-wrapper">
            <span className="volume-icon">
              <i className="fa fa-volume-up" aria-hidden="true"></i>
            </span>
            <div className="re-volume-wrapper">
              <input
              type="range"
              placeholder="Volume"
              className="volume-control"
              min="0"
              max="100"
              step="1"
              defaultValue={volume}
              onInput={changeRange}
              style={{
                "--progress": `${(volume / 100) * 100
                }%`,
              }}
              />
            </div>
            </div>
          </div>
          </div>

          <div className="row">
          <div className="col-12">
            <div className="mt-3 clearfix">
            <div className="pull-left" id="retell-playback">
              <PlaybackSpeedBtns
              changePlaybackSpeed={changePlaybackSpeed}
              playbackSpeed={playbackSpeed}
              audioFinished={audioFinished}
              // answer={props.answer}
              // sound={soundStatus}
              />
            </div>
            {showSkipAudioWaitButton() && (
              <div className="btn-outer skip-btn-wrapper retell-skip pull-right m-0">
                <button
                  type="button"
                  className="outline-btn skip-btn-new text-center visibility-visible"
                  onClick={skip}
                >
                  Skip
                </button>
              </div>
            )}
            {skipAudio() && (
              <div className="btn-outer skip-btn-wrapper retell-skip pull-right m-0">
              <button
                className="outline-btn skip-btn-new text-center visibility-visible"
                onClick={stopAudio}
              >
                Skip
              </button>
              </div>
            )}
            </div>
          </div>
          </div>
        </div>
        </div>
      </div>
      <div className="recorded-section h-100" style={{ width: "50%" }}>
        <div className="row">
        <div className="w-100">
          {/* <div> */}
          <div className="recorded-content">
          <ul className="recorded-list">
            <li>Status:<span className="text-black"> {recordingLabel()}</span></li>
                      {/* <li>{recordingLabel()}</li> */}
                       {/* {isRecording && (
    <li style={{ color: '#e74c3c', fontWeight: 'bold' }}>
      Recording: {recordCount}s / {LIMIT}s remaining: {LIMIT - recordCount}s
    </li>
  )} */}
                     {isRecording && (
    <li>
      Recording: {LIMIT - recordCount}s
    </li>
  )}
          </ul>
          <div className="recorded-audio-wrapper">
            {showRecordedAudio() ? (
            <div className="mic-waveform-wrapper" style={{ marginTop: "37px" }}>
							<RecordedWaveform
							testMode={false}
							blobURL={blobURL}
							/>
						</div>
            ) : (
            <>
              <div className="mic-waveform-wrapper d-flex" id="retell-micwave">
              {recordCount === 0 ? (
                // <img
                // src="/images/waveform.png"
                // alt="Waveform"
                // />
                <div className="waveform" style={{ marginTop: "48px" }}>
      					  {Array.from({ length: 100 }).map((_, i) => (
      					    <div key={i} className="wave-bar" />
      					  ))}
      					</div>
              ) : (
                <MicWaveform
                progressValue={recordCount * 2.5}
                />
              )}
              {showStopRecordingButton() && (
                <div className="btn-outer">
                  <button
                    type="button"
                    className="outline-btn skip-btn-new text-center mt-2 visibility-visible"
                    onClick={stop}
                  >
                    Stop
                  </button>
                </div>
              )}
              </div>
            </>
            )}
          </div>
          </div>
        </div>
        </div>
      </div>
      </div>
    </>
    ) : (
    <div className="pmw-tabs h-100">
      {micPermitted === false && (
      <div className="alert alert-danger">
        No Microphone permissions granted. Please grant microphone
        permissions and reload the page.
      </div>
      )}

          {/* {browserAllowed === false && (
            <div className="alert alert-danger">
              The browser you are using is not supported. Please use Google
              Chrome.
            </div>
          )} */}
        </div>
      )}
    </>
  );
};

export default RespondToSituation;